import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'RadioButton',
  props: {
	label: { type: String },
	modelValue: { type: [String, Boolean, Number] },
	value: { type: [String, Boolean, Number] },
	name: { type: String },
	disabled: { type: Boolean },
},
  emits: ['input'],
  setup(__props, { emit }) {

const props = __props;





const model = computed({
	get() {
		return props.value
	},
	set() {
		emit('input', props.modelValue)
	},
})

return { __sfc: true,emit, props, model }
}

})